const mergeTags = [{
    'featured': true,
    'slug': 'recipient_name',
    'label': 'Recipient name',
    'description': 'Name of the recipient'
},
{
    'featured': true,
    'slug': 'supporter_name',
    'label': 'Supporter name',
    'description': 'Name of the supporter'
}]

export default mergeTags